import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    redirect: '/order',
    children: [
      { path: 'order', component: () => import('@/views/OrderList.vue'), meta: { title: '订单管理' } },
      { path: 'worker', component: () => import('@/views/WorkerList.vue'), meta: { title: '骑手管理' } },
      { path: 'community', component: () => import('@/views/CommunityList.vue'), meta: { title: '小区管理' } },
      { path: 'member', component: () => import('@/views/MemberList.vue'), meta: { title: '会员管理' } },
      { path: 'user', component: () => import('@/views/UserList.vue'), meta: { title: '用户管理' } },
      { path: 'stats', component: () => import('@/views/Stats.vue'), meta: { title: '数据统计' } },
      { path: 'config', component: () => import('@/views/ConfigList.vue'), meta: { title: '参数配置' } },
      { path: 'account', component: () => import('@/views/AccountList.vue'), meta: { title: '管理员信息' } }
    ]
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
